import { Component, inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser, Location } from '@angular/common';


@Component({
    selector: 'app-kb-vizseek-noresults-popup',
    templateUrl: './kb-vizseek-noresults-popup.component.html',
    styleUrls: ['./kb-vizseek-noresults-popup.component.scss'],
    standalone: false
})
export class KbVizseekNoresultsPopupComponent {
  platformId = inject(PLATFORM_ID); 
  constructor(private router: Router,private location: Location) {
  }

  contactRedirect(){
  const url = this.router.createUrlTree(['contact-us-form']).toString();
  if (isPlatformBrowser(this.platformId)) {
    window.open(this.location.prepareExternalUrl(url), '_blank');
  }
}
}
